import {NgModel} from './ngModel';

export const School = NgModel.extend({
    _name: 'School',
});
